import PropTypes from 'prop-types'
import { useEffect, useState, useRef, useContext } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { CarritoContext } from '../context/carritoContext'
import { LoginContext } from '../context/loginContext'
import {
  calcularTotalItemConIva,
  calcularTotalItemSinIva
} from '../helpers/calcularPrecioTotal'
import createValidador from '../hooks/createValidador'
import FormInsertDomicilio from '../perfil/FormInsertDomicilio'
import CardInputForm from '../reutilizables/cardInputForm/CardInputForm'
import { CheckboxReutilizable } from '../reutilizables/checkbox/Checkbox'
import * as archivoService from '../servicios/archivoAdjuntoService'
import * as carritoService from '../servicios/carritoService'
import * as compraService from '../servicios/compraService'
import * as domiciliosService from '../servicios/domiciliosService'
import * as fetchProvinciasAPI from '../servicios/fetchProvinciasAPI'
import * as listaEnvioService from '../servicios/listaEnvioService'
import * as publicacionesService from '../servicios/publicacionesService'
import BordePrincipal from '../ui/BordePrincipal'
import Checkbox from '../ui/Checkbox'
import Comprobante from './Comprobante'
import { DetallePrecio } from './DetallePrecio'

const ENVIO_DOMICILIO = 1
const ENVIO_A_CARGO_COMPRADOR = 3

const Vendedor = ({ vendedor }) => {
  const [domicilios, setDomicilios] = useState([])
  const [verModalDatosEnvio, setVerModalDatosEnvio] = useState(false)
  const [verComprobante, setVerComprobante] = useState(false)
  const [pedido, setPedido] = useState([])
  const [idMedioEnvio, setIdMedioEnvio] = useState({})
  const [mediosPago, setMediosPago] = useState([])
  const [medioPagoSeleccionado, setMedioPagoSeleccionado] = useState({})
  const [verModalTarjeta, setVerModalTarjeta] = useState(false)
  const [itemSeleccionado, setItemSeleccionado] = useState(null)
  const { loginDataContext } = useContext(LoginContext)
  const [mediosEnvios, setMediosEnvio] = useState([])
  const [listasEnvio, setListasEnvio] = useState({})
  const [listaEnvioSeleccionada, setListaEnvioSeleccionada] = useState({})
  const [verModalNuevoDomicilio, setVerModalNuevoDomicilio] = useState(false)
  const [provinciasAPI, setProvinciasAPI] = useState([])
  const [domicilioPrincipal, setDomicilioPrincipal] = useState(false)
  const [domicilioFacturacion, setDomicilioFacturacion] = useState(false)

  const [direccionEntrega, setDireccionEntrega] = useState({})
  const [cardData, setCardData] = useState({
    number: '',
    name: '',
    expiry: '',
    cvv: ''
  })
  const credito = 2
  const debito = 3
  const tarjetas = [credito, debito]

  const handleAbrirModalNuevoDomicilio = () => {
    setVerModalNuevoDomicilio(true)
    setDomicilioPrincipal(false)
    setDomicilioFacturacion(false)
  }

  const handleGuardarNuevoDomicilio = async (nuevoDomicilio) => {
    try {
      const { data } = await domiciliosService.insertar(nuevoDomicilio)
      if (data.idUsuarioDomicilio) {
        const idUsuario = parseInt(localStorage.getItem('idUsuario'))
        const { data: domiciliosActualizados } = await domiciliosService.buscarTodas(
          idUsuario,
          loginDataContext.tipoUsuario
        )

        setDomicilios(domiciliosActualizados)

        setVerModalNuevoDomicilio(false)
        toast('Domicilio agregado exitosamente')
      }
    } catch {
      toast.error('Error al guardar el domicilio')
    }
  }

  const handleChangeDomicilio = (e) => {
    const { name, checked } = e.target
    if (name === 'domicilioPrincipal') {
      setDomicilioPrincipal(checked)
    } else if (name === 'domicilioFacturacion') {
      setDomicilioFacturacion(checked)
    }
  }

  const navigate = useNavigate()

  const { setCantidad, setItems, items } = useContext(CarritoContext)

  const [chktyc, setChktyc] = useState(null)
  const [error, setError] = useState('')
  const [tycfile, setTycfile] = useState(null)
  const [errorTarjetas, setErrorTarjeta] = useState({})

  const tyc = useRef()
  const { Validador } = createValidador()

  const esquema = {
    tyc: Validador.Kernel.any()
      .empty(null)
      .required()
      .label('TyC')
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': (
            <>Para continuar debes aceptar los Términos y Condiciones del vendedor.</>
          )
        })
      })
  }

  const valido = (name) => {
    const error = Validador.validarDato(
      esquema,
      {
        tyc: chktyc
      },
      name
    )

    if (error) {
      setError(error.tyc)
      return false
    } else {
      return true
    }
  }

  const obtenerMediosDePago = async () => {
    const { data } = await publicacionesService.BuscarMediosDePago(0)
    setMediosPago(data.map((m) => ({ value: m.idMedioPago, label: m.nombre })))
  }

  const obtenerMediosEnvio = async () => {
    const { data } = await publicacionesService.buscarMedioEnvio()
    setMediosEnvio(data.map((m) => ({ value: m.idMedioEnvio, label: m.nombre })))
  }

  const obtenerListasEnvioDelVendedor = async () => {
    const listasEnvioPorProducto = {}

    for (const item of vendedor.pedidoItems) {
      const { data } = await listaEnvioService.buscarListaPorVendedor(
        vendedor.idVendedor,
        item.idPublicacion
      )
      const listasValidas = data.filter((lista) => {
        if (!lista.grilla || lista.grilla.length === 0) {
          return false
        }

        const filaValida = lista.grilla.find((fila) => {
          return (
            fila.cantidadDesde &&
            fila.cantidadHasta &&
            fila.costo &&
            item.cantidad >= fila.cantidadDesde &&
            item.cantidad <= fila.cantidadHasta
          )
        })

        return !!filaValida
      })

      const listasFormateadas = listasValidas.map((l) => {
        const filaValida = l.grilla.find((fila) => {
          return (
            item.cantidad >= fila.cantidadDesde && item.cantidad <= fila.cantidadHasta
          )
        })

        const filaAMostrar = filaValida || l.grilla[0] || {}

        return {
          value: `${item.idPublicacion}-${l.idLista}`,
          idLista: l.idLista,
          label: `${l.nombreLista} | ${filaAMostrar.zona} | ${filaAMostrar.cantidadDesde}-${filaAMostrar.cantidadHasta} | $${filaAMostrar.costo}`,
          nombreLista: l.nombreLista,
          zona: filaAMostrar.zona,
          cantidadDesde: filaAMostrar.cantidadDesde,
          cantidadHasta: filaAMostrar.cantidadHasta,
          precio: filaAMostrar.costo,
          grilla: l.grilla
        }
      })

      listasEnvioPorProducto[item.idPublicacion] = listasFormateadas
    }

    setListasEnvio(listasEnvioPorProducto)
  }

  const calcularListasAgrupadasPorEnvio = () => {
    const listasMap = new Map()

    vendedor.pedidoItems.forEach((item) => {
      if (idMedioEnvio[item.idPublicacion] !== ENVIO_A_CARGO_COMPRADOR) {
        return
      }

      const listasDelItem = listasEnvio[item.idPublicacion] || []
      if (listasDelItem.length > 0) {
        const listaAplicable = listasDelItem[0]
        const nombreLista = listaAplicable.nombreLista
        if (listasMap.has(nombreLista)) {
          const existente = listasMap.get(nombreLista)
          existente.cantidadTotal += item.cantidad
        } else {
          listasMap.set(nombreLista, {
            cantidadTotal: item.cantidad,
            listaInfo: listaAplicable
          })
        }
      }
    })

    return {
      listasMap,
      tieneMultiplesListas: listasMap.size > 1
    }
  }

  const debeConsultarAlVendedor = () => {
    const productosConEnvioComprador = vendedor.pedidoItems.filter(
      (item) => idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR
    )

    if (productosConEnvioComprador.length === 0) {
      return { debeConsultar: false, motivo: null }
    }

    const { listasMap, tieneMultiplesListas } = calcularListasAgrupadasPorEnvio()

    if (tieneMultiplesListas) {
      return { debeConsultar: true, motivo: 'multiplesListas' }
    }

    for (const [, info] of listasMap) {
      const cantidadTotal = info.cantidadTotal
      const listaInfo = info.listaInfo

      if (!listaInfo || !listaInfo.grilla || listaInfo.grilla.length === 0) {
        return { debeConsultar: true, motivo: 'sinGrilla' }
      }

      const filaValida = listaInfo.grilla.find((fila) => {
        return cantidadTotal >= fila.cantidadDesde && cantidadTotal <= fila.cantidadHasta
      })

      if (!filaValida) {
        return { debeConsultar: true, motivo: 'cantidadSuperaMáximo' }
      }
    }

    return { debeConsultar: false, motivo: null }
  }

  useEffect(() => {
    obtenerAdjunto()
    obtenerDomicilios(parseInt(localStorage.getItem('idUsuario')))
    obtenerMediosDePago()
    obtenerMediosEnvio()
    obtenerProvincias()
    obtenerListasEnvioDelVendedor()
  }, [])

  const obtenerProvincias = async () => {
    const { data: provinciasAPI } = await fetchProvinciasAPI.buscarProvinciasEnEBM()
    setProvinciasAPI(provinciasAPI)
  }

  const obtenerAdjunto = async () => {
    const idTipoTYC = 8
    const { data: adjunto } = await archivoService.buscarArchivo(
      vendedor.idVendedor,
      idTipoTYC
    )
    const adj = URL.createObjectURL(adjunto)
    setTycfile(adj)
  }

  const obtenerDomicilios = async (idUsuario) => {
    const { data: domTemp } = await domiciliosService.buscarTodas(
      idUsuario,
      loginDataContext.tipoUsuario
    )
    if (domTemp.length === 0) {
      navigate('/AdministrarDomicilios')
    } else {
      setDomicilios(domTemp)
    }
  }

  const handleClickMedioEnvio = (idMedioEnvio, idPublicacion) => {
    setIdMedioEnvio((prev) => ({
      ...prev,
      [idPublicacion]: idMedioEnvio
    }))
    setError('')
    setListaEnvioSeleccionada({})
  }

  const handleClickDomicilioEnvio = (selected, idPublicacion) => {
    if (!selected) {
      setError('Debes seleccionar un domicilio de envío')
      return
    }
    const domicilioSeleccionado = domicilios.find(
      (d) => d.idUsuarioDomicilio === selected.value
    )
    if (!domicilioSeleccionado) {
      setError('Domicilio no encontrado')
      return
    }

    setDireccionEntrega((prev) => ({
      ...prev,
      [idPublicacion]: {
        idUsuarioDomicilio: domicilioSeleccionado.idUsuarioDomicilio,
        provincia: domicilioSeleccionado.provincia,
        idLocalidad: domicilioSeleccionado.idLocalidad,
        localidad: domicilioSeleccionado.localidad,
        cp: domicilioSeleccionado.cp,
        calle: domicilioSeleccionado.calle,
        calleAltura: domicilioSeleccionado.calleAltura,
        piso: domicilioSeleccionado.piso,
        departamento: domicilioSeleccionado.departamento
      }
    }))

    setError('')
  }

  const handleClickListaEnvio = (lista, idPublicacion) => {
    setListaEnvioSeleccionada((prev) => ({
      ...prev,
      [idPublicacion]: lista
    }))
    setError('')
  }

  const mostrarComprobante = (pedido) => {
    setVerModalDatosEnvio(false)
    setVerComprobante(true)
    eliminarCarrito(pedido)
  }

  const crearPedido = async (pedido) => {
    const { data: rtn } = await compraService.crearPedido(pedido)
    setPedido(rtn)
    if (rtn.idPedido > 0) {
      mostrarComprobante(pedido)
    }
  }

  const eliminarCarritoItem = async (item) => {
    const { data: carritoCantidad } = await carritoService.eliminar({
      idPublicacion: item.idPublicacion,
      idUsuario: parseInt(localStorage.getItem('idUsuario'))
    })
    setCantidad(carritoCantidad)
  }

  const eliminarCarrito = async (pedido) => {
    pedido.pedidoItems.forEach((item) => {
      eliminarCarritoItem(item)
      const newItems = items.filter((i) => i.idPublicacion !== item.idPublicacion)
      setItems(newItems)
    })
  }

  const handlerContinuar = (vendedor) => {
    const idPublicacion = vendedor.pedidoItems.map((item) => item.idPublicacion)

    if (idPublicacion.some((id) => !idMedioEnvio[id])) {
      setError('Debe seleccionar un tipo de entrega para todos los productos')
      return
    }

    const publicacionesConEnvio = idPublicacion.filter(
      (id) =>
        idMedioEnvio[id] === ENVIO_DOMICILIO ||
        idMedioEnvio[id] === ENVIO_A_CARGO_COMPRADOR
    )

    const faltaDomicilio = publicacionesConEnvio.some(
      (id) =>
        !direccionEntrega[id] ||
        direccionEntrega[id].idUsuarioDomicilio === undefined ||
        direccionEntrega[id].idUsuarioDomicilio === null
    )

    if (publicacionesConEnvio.length > 0 && faltaDomicilio) {
      setError('Debes seleccionar un domicilio de envío')
      return
    }

    const publicacionesConEnvioComprador = idPublicacion.filter(
      (id) => idMedioEnvio[id] === ENVIO_A_CARGO_COMPRADOR
    )

    if (
      publicacionesConEnvioComprador.length > 0 &&
      publicacionesConEnvioComprador.some((id) => !listaEnvioSeleccionada[id])
    ) {
      setError('Debes seleccionar una lista de envío')
      return
    }

    if (idPublicacion.some((id) => !medioPagoSeleccionado[id])) {
      setError('Debes seleccionar un medio de pago para todos los productos')
      return
    }

    if (!valido('tyc')) {
      return
    }

    const totalConIva = vendedor.pedidoItems.reduce(
      (total, item) => total + calcularTotalItemConIva(item),
      0
    )

    const checkoutDTO = {
      ...vendedor,
      pedidoItems: vendedor.pedidoItems.map((item) => {
        const domicilio = direccionEntrega[item.idPublicacion] || {}
        const listaSeleccionada = listaEnvioSeleccionada[item.idPublicacion]

        return {
          ...item,
          entregaProvincia: domicilio.provincia || '',
          entregaLocalidad: domicilio.idLocalidad || 0,
          entregaLocalidadDesc: domicilio.localidad || '',
          entregaCP: domicilio.cp || '',
          entregaCalle: domicilio.calle || '',
          entregaCalleAltura: domicilio.calleAltura || '',
          entregaPiso: domicilio.piso || '',
          entregaDpto: domicilio.departamento || '',
          idMedioEnvio: idMedioEnvio[item.idPublicacion],
          idMedioPago: medioPagoSeleccionado[item.idPublicacion],
          precioEnvio: listaSeleccionada?.precio || 0,
          total: totalConIva
        }
      })
    }

    crearPedido(checkoutDTO)
  }

  const ocultarModal = () => {
    setChktyc(null)
    setVerModalDatosEnvio(false)
    setListaEnvioSeleccionada({})
    setMedioPagoSeleccionado({})
    setDireccionEntrega({})
  }

  const total = vendedor.pedidoItems.reduce(
    (total, item) => total + calcularTotalItemConIva(item),
    0
  )

  const calcularCostoEnvioTotal = () => {
    // Buscar el primer producto con envío a cargo del comprador que tenga lista seleccionada
    const primerProductoConLista = vendedor.pedidoItems.find((item) => {
      return (
        idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR &&
        listaEnvioSeleccionada[item.idPublicacion]
      )
    })

    // Si existe, retornar su precio (solo una vez)
    if (primerProductoConLista) {
      const lista = listaEnvioSeleccionada[primerProductoConLista.idPublicacion]
      return lista?.precio || 0
    }

    // Si no hay productos con envío a cargo del comprador, sumar otros tipos de envío
    return vendedor.pedidoItems.reduce((totalEnvio, item) => {
      if (idMedioEnvio[item.idPublicacion] !== ENVIO_A_CARGO_COMPRADOR) {
        const listaSeleccionada = listaEnvioSeleccionada[item.idPublicacion]
        if (listaSeleccionada && listaSeleccionada.precio) {
          return totalEnvio + listaSeleccionada.precio
        }
      }
      return totalEnvio
    }, 0)
  }

  const costoEnvio = calcularCostoEnvioTotal()
  const totalConEnvio = total + costoEnvio

  const totalSinIva = vendedor.pedidoItems.reduce(
    (total, item) => total + calcularTotalItemSinIva(item),
    0
  )

  const esMayorista = (item) => {
    if (!item?.preciosMayoristas || item.preciosMayoristas.length === 0) {
      return null
    }

    const toNumber = (valor) => {
      const num = Number(valor)
      return Number.isFinite(num) ? num : 0
    }

    const tiersValidos = item.preciosMayoristas
      .map((p) => ({
        cantidad: toNumber(p.cantidad),
        precioUnitario: toNumber(p.precioUnitario)
      }))
      .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)

    if (tiersValidos.length === 0) {
      return null
    }

    const aplicables = tiersValidos.filter((tier) => item.cantidad >= tier.cantidad)
    if (aplicables.length === 0) {
      return null
    }

    return aplicables.reduce((prev, curr) =>
      curr.cantidad > prev.cantidad ? curr : prev
    )
  }

  const valorUnitarioSinIva = (item) => {
    const mayorista = esMayorista(item)
    const toNumber = (valor) => {
      const num = Number(valor)
      return Number.isFinite(num) ? num : 0
    }

    if (mayorista) {
      return mayorista.precioUnitario
    }

    const unitario = toNumber(item.precioUnitario)
    if (unitario > 0) {
      return unitario
    }

    const totalConIva = toNumber(item.valorTotalConIva)
    const cant = toNumber(item.cantidad) || 1
    return cant > 0 ? totalConIva / cant : 0
  }

  const opciones = domicilios.map((d) => ({
    value: d.idUsuarioDomicilio,
    label: `${d.tipoDomicilio} - ${[d.calle, d.localidad, d.provincia]
      .filter(Boolean)
      .join(', ')}${d.domicilioPrincipal ? ' (Principal)' : ''}`
  }))

  const guardarTarjeta = () => {
    const errores = {}

    if (!cardData.number) {
      errores.number = 'El número de tarjeta es obligatorio.'
    } else if (!/^\d{16}$/.test(cardData.number.replace(/\s+/g, ''))) {
      errores.number = 'Debe tener 16 dígitos numéricos.'
    }

    if (!cardData.name) {
      errores.name = 'El nombre es obligatorio.'
    }

    if (!cardData.expiry) {
      errores.expiry = 'El vencimiento es obligatorio.'
    } else if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(cardData.expiry)) {
      errores.expiry = 'Formato inválido (MM/AA).'
    } else {
      const [month, year] = cardData.expiry.split('/')
      const expiryDate = new Date(`20${year}`, month)
      const now = new Date()
      if (expiryDate < now) {
        errores.expiry = 'La tarjeta está vencida.'
      }
    }

    if (!cardData.cvv) {
      errores.cvv = 'El CVV es obligatorio.'
    } else if (!/^\d{3,4}$/.test(cardData.cvv)) {
      errores.cvv = 'Debe tener 3 o 4 dígitos.'
    }
    if (Object.keys(errores).length > 0) {
      setErrorTarjeta(errores)
    } else {
      setVerModalTarjeta(false)
    }
  }

  const detallePrecioProps = {
    vendedor,
    valorUnitarioSinIva,
    esMayorista,
    total,
    costoEnvio,
    totalConEnvio,
    totalSinIva
  }

  return verComprobante ? (
    <Comprobante vendedor={vendedor} pedido={pedido} medioPago={medioPagoSeleccionado} />
  ) : (
    <div className="row mt-4 borde-perfil ml-auto mr-auto" key={vendedor.idVendedor}>
      <div className="col-12 text-center">
        <h3>Vendedor: {vendedor.razonSocial || vendedor.pedidoItems[0].nombre}</h3>
      </div>

      <DetallePrecio {...detallePrecioProps} usaImagen={true} />

      <div className="row no-gutters mt-5 w-25">
        <button
          type="button"
          className="btn btn btn-volver-comprar"
          id="checkout-btn"
          onClick={() => setVerModalDatosEnvio(true)}
        >
          Continuar compra
        </button>
      </div>

      <Modal
        show={verModalDatosEnvio}
        onHide={() => ocultarModal()}
        size={'xlg'}
        animation={false}
      >
        <form>
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Confirmá los datos de tu Envío</h3>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <BordePrincipal titulo="Medios de pago y Entrega">
              <table className="table table-striped align-middle">
                <thead>
                  <tr>
                    <th>Ítem</th>
                    <th>Tipo de Entrega</th>
                    <th>Domicilio de Envío</th>
                    <th>Lista de Envío</th>
                    <th>Medio de Pago</th>
                  </tr>
                </thead>
                <tbody>
                  {vendedor.pedidoItems.map((item) => (
                    <tr key={item.idPublicacion}>
                      <td>{item.titulo}</td>

                      <td>
                        <div className="d-flex col">
                          {mediosEnvios
                            .filter((opcion) =>
                              item.mediosEnvios.includes(opcion.value.toString())
                            )
                            .map((opcion) => (
                              <CheckboxReutilizable
                                key={opcion.value}
                                label={opcion.label}
                                checked={
                                  idMedioEnvio[item.idPublicacion] === opcion.value
                                }
                                onChange={() =>
                                  handleClickMedioEnvio(opcion.value, item.idPublicacion)
                                }
                                name={`idMedioEnvio-${item.idPublicacion}`}
                              />
                            ))}
                        </div>
                      </td>

                      <td>
                        {idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR ||
                        idMedioEnvio[item.idPublicacion] === ENVIO_DOMICILIO ? (
                          <>
                            <div className="d-flex align-items-center">
                              <Select
                                key={domicilios.length}
                                options={opciones}
                                value={opciones.find(
                                  (o) =>
                                    o.value ===
                                    (direccionEntrega[item.idPublicacion]
                                      ?.idUsuarioDomicilio || null)
                                )}
                                onChange={(selected) =>
                                  handleClickDomicilioEnvio(selected, item.idPublicacion)
                                }
                                isSearchable
                                placeholder="Selecciona un domicilio"
                              />
                              {loginDataContext.tipoUsuario !== 'A' && (
                                <div
                                  className="text-primary fw-bold col"
                                  style={{ cursor: 'pointer' }}
                                  title="Agregar nuevo domicilio"
                                  onClick={handleAbrirModalNuevoDomicilio}
                                >
                                  +
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <span className="text-muted">—</span>
                        )}
                      </td>

                      <td style={{ minWidth: '200px' }}>
                        {idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR ? (
                          <>
                            {(() => {
                              const listasDelProducto =
                                listasEnvio[item.idPublicacion] || []
                              const resultado = debeConsultarAlVendedor()
                              const sinListas =
                                !listasDelProducto || listasDelProducto.length === 0

                              if (sinListas) {
                                return (
                                  <button
                                    type="button"
                                    className="btn btn-warning btn-sm"
                                    onClick={() =>
                                      navigate(`/Publicacion/${item.idPublicacion}`)
                                    }
                                    title="No hay listas de envío disponibles para la cantidad seleccionada"
                                  >
                                    Consultar al vendedor
                                    <br />
                                    <small>
                                      (Sin lista para cantidad {item.cantidad})
                                    </small>
                                  </button>
                                )
                              }

                              if (resultado.debeConsultar) {
                                const mensajeMotivo =
                                  resultado.motivo === 'multiplesListas'
                                    ? 'Múltiples listas en carrito'
                                    : resultado.motivo === 'cantidadSuperaMáximo'
                                      ? `Cantidad total supera máximo disponible`
                                      : 'Configuración inválida'

                                return (
                                  <button
                                    type="button"
                                    className="btn btn-warning btn-sm"
                                    onClick={() =>
                                      navigate(`/Publicacion/${item.idPublicacion}`)
                                    }
                                    title={
                                      resultado.motivo === 'multiplesListas'
                                        ? 'Los productos tienen listas de envío diferentes'
                                        : 'La cantidad total supera el máximo disponible en la lista'
                                    }
                                  >
                                    Consultar al vendedor
                                    <br />
                                    <small>({mensajeMotivo})</small>
                                  </button>
                                )
                              }

                              return (
                                <Select
                                  options={listasDelProducto}
                                  value={
                                    listaEnvioSeleccionada[item.idPublicacion] || null
                                  }
                                  onChange={(selected) =>
                                    handleClickListaEnvio(selected, item.idPublicacion)
                                  }
                                  isSearchable
                                  placeholder="Selecciona una lista de envío"
                                />
                              )
                            })()}
                          </>
                        ) : (
                          <span className="text-muted">—</span>
                        )}
                      </td>

                      <td style={{ minWidth: '200px' }}>
                        <Select
                          options={mediosPago.filter((m) =>
                            item.mediosPagos.includes(m.value.toString())
                          )}
                          value={
                            mediosPago.find(
                              (o) =>
                                o.value ===
                                (medioPagoSeleccionado?.[item.idPublicacion] || null)
                            ) || null
                          }
                          onChange={(selected) => {
                            const value = selected ? selected.value : null
                            setMedioPagoSeleccionado((prev) => ({
                              ...prev,
                              [item.idPublicacion]: value
                            }))
                            setError('')

                            if (tarjetas.includes(Number(value))) {
                              setItemSeleccionado(item)
                              setVerModalTarjeta(true)
                            }
                          }}
                          placeholder="Selecciona un medio"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <DetallePrecio {...detallePrecioProps} titulo="Detalle de pago" />
            </BordePrincipal>
            <div className="col text-center mt-4">
              <Checkbox
                type="checkbox"
                name="tyc"
                ref={tyc}
                className="mr-2"
                onClick={() => {
                  setChktyc(tyc.current.checked ? 'on' : null)
                  setError('')
                }}
              />
              Aceptar{' '}
              <a className="mr-2" href={tycfile} target="_blank" rel="noreferrer">
                Términos y Condiciones de Venta
              </a>
              del vendedor.
            </div>
            <div className="text-center">
              {error && <div className="text-danger mt-2">{error}</div>}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="text-center w-100 mb-2 gap-2 d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-enviar w-20"
                onClick={ocultarModal}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-volver-comprar w-20"
                onClick={() => handlerContinuar(vendedor)}
              >
                Confirmar Operación
              </button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={verModalTarjeta}
        onHide={() => setVerModalTarjeta(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Datos de la tarjeta
            {itemSeleccionado && (
              <span style={{ fontSize: '0.9rem', marginLeft: '10px', color: '#666' }}>
                – {itemSeleccionado.titulo}
              </span>
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <CardInputForm
            cardData={cardData}
            setCardData={setCardData}
            errorTarjetas={errorTarjetas}
          />
        </Modal.Body>

        <Modal.Footer>
          <div className="text-center w-100 mb-2 gap-2 d-flex justify-content-center">
            <button
              type="button"
              className="btn btn-enviar w-50"
              onClick={() => setVerModalTarjeta(false)}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-volver-comprar w-50"
              onClick={() => guardarTarjeta()}
            >
              Guardar
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={verModalNuevoDomicilio}
        onHide={() => setVerModalNuevoDomicilio(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Domicilio</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <FormInsertDomicilio
            domicilioPrincipal={domicilioPrincipal}
            domicilioFacturacion={domicilioFacturacion}
            onNew={handleGuardarNuevoDomicilio}
            onChangeDomicilio={handleChangeDomicilio}
            provinciasAPI={provinciasAPI}
            onCancel={() => setVerModalNuevoDomicilio(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  )
}

Vendedor.propTypes = {
  vendedor: PropTypes.shape({
    idVendedor: PropTypes.number.isRequired,
    razonSocial: PropTypes.string,
    pedidoItems: PropTypes.arrayOf(
      PropTypes.shape({
        idPublicacion: PropTypes.number.isRequired,
        titulo: PropTypes.string,
        nombre: PropTypes.string,
        cantidad: PropTypes.number,
        cantidadMayorista: PropTypes.number,
        precioUnitario: PropTypes.number,
        precioUnitarioMayorista: PropTypes.number,
        alicuota: PropTypes.number,
        monedaSimbolo: PropTypes.string
      })
    ).isRequired
  }).isRequired
}
export default Vendedor
